import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
interface Data {
  roles: any;
}
@Component({
  standalone: false,
  selector: 'app-remove-role-dialog',
  templateUrl: './remove-role-dialog.component.html',
  styleUrls: ['./remove-role-dialog.component.scss']
})
export class RemoveRoleDialogComponent implements OnInit {
  roleName: string;
  inputValue: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Data,
    public dialogRef: MatDialogRef<RemoveRoleDialogComponent>
  ) {}

  ngOnInit() {
    this.roleName = this.data.roles[0].role;
  }
  getValue(input) {
    this.inputValue = input
  }
  
  close() {
    this.dialogRef.close();
  }
}
